import React from 'react';
import { Container } from 'react-bootstrap';

const StaticPage = ({ title, children }) => (
  <div className="py-5">
    <Container>
      <h1 className="mb-4">{title}</h1>
      <div className="lead" style={{ whiteSpace: 'pre-line' }}>
        {children}
      </div>
    </Container>
  </div>
);

export default StaticPage;
